import React from 'react'
import MediaAvatar from '../../../atoms/MediaAvatar'
import RemoveAsigneeButton from '../RemoveAssigneeButton'

import { useUserAPI } from '../../../../providers/UserAPIProvider'

const AsigneeRow = ({ userId, classes, canEdit, handleRemoveAsignee }) => {
  const { allUsers, loadUser } = useUserAPI()
  const user = allUsers[userId]

  React.useEffect(() => {
    if (!user) {
      loadUser(userId)
    }
  }, [user, loadUser, userId])

  return (
    <span className={classes.editableAsigneeRow}>
      <MediaAvatar user={user} className={classes.editableAsigneeRowAvatar} />
      <label className={classes.truncate}>{user?.name || '...'}</label>
      {canEdit && (
        <RemoveAsigneeButton onClick={() => handleRemoveAsignee(userId)} />
      )}
    </span>
  )
}
export default AsigneeRow
